
























import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import WordFade from '@/common/vue/WordFade.vue';
import ParentComponentMixin from '@/common/ts/child-component/ParentComponentMixin';
import ChildComponentCollection from '@/common/ts/child-component/ChildComponentCollection';
import SubFooterSectionsItem from '@/webcomponents/footer-sections/SubFooterSectionsItem.vue';
import BackgroundColorMixin from '@/common/ts/background-color/BackgroundColorMixin';

const FooterSectionItemProps = Vue.extend({
  props: {
    editMode: Boolean,
    pageOpenedInEditMode: Boolean,
    sectionHeadline: String,
    itemIndex: Number,
  },
});

@Component({
  components: {
    WordFade,
  },
})
export default class FooterSectionsItem extends mixins(FooterSectionItemProps, ChildComponentMixin, ParentComponentMixin, BackgroundColorMixin) {
  $refs!: {
    headline: HTMLElement;
    wordFade: WordFade;
  }

  items: ChildComponentCollection<SubFooterSectionsItem> = new ChildComponentCollection<SubFooterSectionsItem>();
  isShown = false;
  isHiddenBelow = false;
  isHiddenAbove = false;

  created () {
    this.initChildComponentMixin(
      'FooterSectionsItem',
    );
    this.initParentComponentMixin(
      this.items,
      ['SubFooterSectionsItem'],
      this.onItemAdded,
    );
  }

  mounted () {
    if (this.editModeOrPageOpenedInEditMode) {
      this.fadeIn();
    }
  }

  onItemAdded (addedItem: Vue) {
    (addedItem as SubFooterSectionsItem).parentIndex = this.index;
  }

  @Watch('index')
  onIndexUpdated () {
    this.updateSubItemsParentIndex();
  }

  get myItemIndex () {
    return `--item-index: ${this.itemIndex}`;
  }

  updateSubItemsParentIndex () {
    this.items.forEach((item) => {
      item.parentIndex = this.index;
    });
  }

  jumpToThisSection () {
    const footerSections = window.document.querySelector('brandhub-footer-sections');
    if (footerSections) {
      const shadow = footerSections.shadowRoot;
      if (shadow) {
        const placeholders = shadow.querySelector('.brandhub-footer-sections__item-placeholders');
        if (placeholders && placeholders.children.length >= this.itemIndex) {
          placeholders.children[this.itemIndex].scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }

  fadeIn () {
    this.isHiddenAbove = false;
    this.isHiddenBelow = false;
    this.delay(500).then(this.fadeInTest);
  }

  fadeInTest () {
    this.isShown = true;
  }

  fadeOut (toTop = true) {
    this.isHiddenAbove = false;
    this.isHiddenBelow = false;
    if (toTop) {
      this.isHiddenAbove = true;
    } else {
      this.isHiddenBelow = true;
    }
    this.isShown = false;
  }

  resetContainerState (event: TransitionEvent) {
    if (event.propertyName === 'transform') {
      if ((event.target as HTMLElement).className.includes('brandhub-footer-sections-item__link-container--shown brandhub-footer-sections-item__link-container--hidden-above')
        || (event.target as HTMLElement).className.includes('brandhub-footer-sections-item__link-container--shown brandhub-footer-sections-item__link-container--hidden-below')) {
        this.isHiddenBelow = false;
        this.isHiddenAbove = false;
        this.isShown = false;
      }
    }
  }

  delay (time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  // for experience fragment in aem: edit-mode is not active for the component in the experience
  // fragment but we are currently still in the author view and have to apply the same behaviour
  // as for edit-mode
  get editModeOrPageOpenedInEditMode (): boolean {
    return this.editMode || this.pageOpenedInEditMode;
  }

  get rootClass () {
    return {
      'brandhub-footer-sections-item--edit-mode': this.editModeOrPageOpenedInEditMode,
    };
  }

  get hideAndShowClass () {
    return {
      'brandhub-footer-sections-item__link-container--shown': this.isShown,
      'brandhub-footer-sections-item__link-container--hidden-above': this.isHiddenAbove,
      'brandhub-footer-sections-item__link-container--hidden-below': this.isHiddenBelow,
    };
  }

  get highlightHeadline () {
    return {
      'brandhub-footer-sections-item__headline--shown': this.isShown,
    };
  }
}

